import { render } from "./UiButton.vue?vue&type=template&id=47029ffc&scoped=true&ts=true"
import script from "./UiButton.vue?vue&type=script&lang=ts"
export * from "./UiButton.vue?vue&type=script&lang=ts"

import "./UiButton.vue?vue&type=style&index=0&id=47029ffc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47029ffc"]])

export default __exports__